export default function MenuHandler() {
    const burger = document.querySelector('[data-menu-burger]');

    if (burger) {
        const menu = document.querySelector('[data-menu]');
        
        burger.addEventListener('click', () => {
            burger.classList.toggle('active');
            menu.classList.toggle('open');
        });
    }
}